import axios from "axios";

import { EntityKind } from "../models/entityKind";

const userServiceRoot = process.env.REACT_APP_USER_SERVICE;

export async function loadSavedFilters(projectId?: string, entityKind?: EntityKind) {
  const req: { projectID?: string; entityKind?: EntityKind } = {};
  if (projectId !== undefined) req.projectID = projectId;
  if (entityKind !== undefined) req.entityKind = entityKind;
  const response = await axios.post(process.env.REACT_APP_SAVED_FILTER_GQL_SERVICE, {
    operationName: "savedFilters",
    variables: { req },
    query:
      "query savedFilters($req: SavedFilterInput!) {\n  savedFilters(req: $req) {\n    id\n    name\n    projectID\n    projectName\n    filterJSON\n    owner\n    filterScope\n    __typename\n  }\n}\n"
  });
  if (response.status === 200) {
    // EVA-257 is deliberately NOT applied here. This helper serves two very
    // different consumers: useGetProjectSavedFilters, which feeds a filter the
    // user is about to look at, and useGetAllAvailableSavedFilters, which feeds
    // the org geo-calculation and geo-simulation screens, where filterJSON is
    // job input that gets compared against and persisted. Emptying a body there
    // would report every existing job as changed and then submit the emptied
    // filter, running a job scoped to a filter over the whole well set. The
    // reshape belongs to the consumer that shows a filter, not to the fetch.
    return response.data.data;
  }
  return null;
}

export async function setDefaultTypeWell(payload) {
  try {
    const response = await axios.post(
      `${userServiceRoot}/user/setting/DefaultTypeWell/`,
      payload
    );
    if (response.status !== 200) {
      return null;
    }
    return response;
  } catch (error) {
    return null;
  }
}
